<template>
    <div>
        <resource-form ref="resourceForm" :open_button="false" :endpoint="endpoint" :method="method" :rules="rules" :schema="schema" :model="subscriptionModel"
                       @closed="closed()">
            <template #title>{{'page.subscriptions.new_subscription' | trans}}</template>
            <template #form="{ resource }">
                <v-flex xs12>
                    <v-text-field v-model="resource.duration"
                                  required
                                  :label="'app.duration' | trans"
                                  :rules="rules.duration"
                    ></v-text-field>
                </v-flex>
                <v-flex xs12>
                    <v-select
                            v-model="resource.role_to_assign"
                            :items="rolesToAssign"
                            :label="'app.type' | trans"
                            :rules="rules.role_to_assign"
                    ></v-select>
                </v-flex>
            </template>
        </resource-form>
    </div>
</template>

<script>
    import has from 'lodash/has';
    import {trans} from "../../../app";
    import {DIETITIAN_PREMIUM, DIETITIAN_STANDARD, DIETITIAN_STUDENT, DIETITIAN_TEST} from "../../../utils/roles";
    import RulesBuilder from "../../../utils/rulesBuilder";

    export default {
        props: {
            user_id: {
                type: Number,
                default: null,
            },
            dialog: {
                type: Boolean,
                default: false
            }
        },
        data: () => ({
            subscriptionModel: null,
            schema: {
                duration: null,
                role_to_assign: null,
            },
            rulesBuilder: new RulesBuilder(),
        }),
        watch: {
            dialog(value) {
                if (value === true) {
                    this.subscriptionModel = {
                        user_id: this.user_id
                    };
                    this.$refs.resourceForm.open();
                }

                if (value === false) {
                    this.$emit('closed');
                }
            },
            model(val) {
                this.subscriptionModel = val;
            },
        },
        methods: {
            closed() {
                this.$emit('closed');
            }
        },
        computed: {
            method() {
                return has(this.model, 'id') ? 'PATCH' : 'POST';
            },
            endpoint() {
                if (has(this.model, 'id')) {
                    return `/administrator/subscriptions/${this.model.id}`;
                }

                return '/administrator/subscriptions';
            },
            rolesToAssign() {
                return [
                  {text: trans('page.roles.dietitian_student'), value: DIETITIAN_STUDENT},
                  {text: trans('page.roles.dietitian_standard'), value: DIETITIAN_STANDARD},
                  {text: trans('page.roles.dietitian_premium'), value: DIETITIAN_PREMIUM},
                  {text: trans('page.roles.dietitian_test'), value: DIETITIAN_TEST},
                ];
            },
            rules: function () {
              return {
                duration: this.rulesBuilder.addIsIntegerRule(trans('app.duration'))
                    .addRequiredRule(trans('app.duration'))
                    .addNumberBiggerThanRule(trans('app.duration'), 1)
                    .getRules(),
                role_to_assign: this.rulesBuilder.addRequiredRule(trans('app.type'))
                    .getRules(),
              }
            }
        },
    }
    ;
</script>
